module.exports = __webpack_public_path__ + "static/media/c.c90e5d40.png";